import { cn } from '@rocco/utils/cn';
import { TAB_CONTENT_GAP } from '../utils/tab-spacing';

/**
 * About tab intro (Figma 2354:58864).
 *
 * Nothing visible left: the display heading repeated the tab pill above it, and
 * the CTA cluster repeated the profile summary header under the banner, which
 * every tab now carries. What remains is the tab's heading for the document
 * outline, plus the standard gap under the sub-nav.
 */
export const ProfessionalAboutIntroSection = () => {
    return (
        <section
            className={cn(
                'w-full overflow-hidden bg-ground text-[#1f1f21] max-md:hidden md:px-[3.125rem]',
                TAB_CONTENT_GAP,
            )}
        >
            <h2 className="sr-only">About us</h2>
        </section>
    );
};
